<div class="navbar-area" *ngIf="showNavbar">
    <div class="mobile-nav">
        <a routerLink="/" class="logo" style="color: #00F4AA;">Wasla <img width="70" src="assets/img/Wasla - circle.png" alt="Logo"></a>
    </div>
    
    <div class="main-nav">
        <div class="container-fluid">
            <nav class="container-max navbar navbar-expand-md navbar-light ">
                <a class="navbar-brand" routerLink="/"><img src="assets/img/logo/logo.png" width="100" alt="Logo"></a>

                <div class="collapse navbar-collapse mean-menu" id="navbarSupportedContent">
                    <ul class="navbar-nav m-auto">
                        <li class="nav-item"><a routerLink="/" class="nav-link">الرئيسية</a></li>                        
                        <li class="nav-item"><a href="#categorySection" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">الاقسام</a></li>                       
                        <li class="nav-item"><a href="https://wa.me/+201220566300" target="_blank" class="nav-link">تواصل معنا</a></li>
                        
                        <!-- mobile menu only -->
                        <li *ngIf="isLogged" class="nav-item mobile-nav-only">
                            <a routerLink="/cart" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">السله (<span>{{quantityCounter}}</span>)</a>
                        </li>
                        <li *ngIf="isLogged" class="nav-item mobile-nav-only">
                            <a routerLink="/orders" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">طلباتي</a>
                        </li>
                        <li *ngIf="isLogged" class="nav-item mobile-nav-only">
                            <a routerLink="/login-register" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" (click)="logOut()">تسجيل خروج</a>
                        </li>
                        <li *ngIf="!isLogged" class="nav-item mobile-nav-only">
                           <a *ngIf="!isLogged" routerLink="/login-register" class="nav-link" routerLinkActive="active">تسجيل دخول</a>
                        </li>
                        
                    </ul>

                    <div class="side-nav d-in-line align-items-center">
                        <div *ngIf="isLogged" class="side-item">
                            <div class="cart-btn">
                                <a routerLink="/cart">
                                    <i class="flaticon-shopping-bags"></i>
                                    <span>{{quantityCounter}}</span>
                                </a>
                            </div>
                        </div>

                        <!-- <div class="side-item">
                            <div class="nav-add-btn">
                                <a routerLink="/" class="default-btn border-radius">Add Listing <i class='bx bx-plus'></i></a>
                            </div>
                        </div> -->

                        <!-- <div class="side-item">
                            <div class="search-box">
                                <i class="flaticon-loupe"></i>
                            </div>
                        </div> -->

                        <div class="side-item">
                            <div class="user-btn">
                                

                                <ul class="navbar-nav m-auto">

                                    <li *ngIf="isLogged" class="nav-item">
                                        <a href="javascript:void(0)" class="nav-link">
                                            <img *ngIf="isLogged" [src]="avatar" width="37" class="img-fluid">
                                            <a *ngIf="!isLogged" routerLink="/"><i class="flaticon-contact"></i></a>
                                        </a>
                                        
                                        <ul class="dropdown-menu">
                                            <!-- <li class="nav-item"><a routerLink="/profile" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">الصفحة الشخصية</a></li> -->
                                            <li class="nav-item"><a routerLink="/orders" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">طلباتي</a></li>
                                            <!-- <li class="nav-item"><a routerLink="/favorites" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">المتاجر المفضلة</a></li> -->
                                            <!-- <li class="nav-item"><a routerLink="/favorite-products" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">المنتجات المفضلة</a></li> -->
                                            <li class="nav-item"><a routerLink="/login-register" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" (click)="logOut()">تسجيل خروج</a></li>
                                        </ul>
                                    </li>

                                    <li *ngIf="!isLogged" class="nav-item">
                                        <a href="javascript:void(0)" class="nav-link">
                                            <img *ngIf="isLogged" [src]="avatar" width="37" class="img-fluid">
                                            <a *ngIf="!isLogged" routerLink="/"><i class="flaticon-contact"></i></a>
                                        </a>
            
                                        <ul class="dropdown-menu">
                                            <li class="nav-item">
                                                <a routerLink="/login-register" class="nav-link" routerLinkActive="active">تسجيل دخول</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>

    <div class="side-nav-responsive">
        <div class="container">
            <!-- <div class="dot-menu me-5">
                <div class="circle-inner">
                    <div class="circle circle-one"></div>
                    <div class="circle circle-two"></div>
                    <div class="circle circle-three"></div>
                </div>
            </div> -->
            
            <div class="container">
                <div class="side-nav-inner">
                    <div class="side-nav justify-content-center  align-items-center">
                        <!-- <div *ngIf="isLogged" class="side-item">
                            <div class="cart-btn">
                                <a routerLink="/cart">
                                    <i class="flaticon-shopping-bags"></i>
                                    <span>{{cartNumber}}</span>
                                </a>
                            </div>
                        </div> -->

                        <!-- <div class="side-item">
                            <div class="search-box">
                                <i class="flaticon-loupe"></i>
                            </div>
                        </div> -->

                        <div class="side-item ps-0 ms-0">
                            <div class="user-btn">
                                <ul class="navbar-nav m-auto">
                                    <!-- <li *ngIf="isLogged" class="nav-item">
                                        <a href="javascript:void(0)" class="nav-link">
                                            <img *ngIf="isLogged" [src]="avatar" width="37" class="img-fluid">
                                            <a *ngIf="!isLogged" routerLink="/"><i class="flaticon-contact"></i></a>
                                        </a>
            
                                        <ul class="dropdown-menu d-none">
                                        </ul>
                                    </li> -->
                                    <li *ngIf="isLogged" class="nav-item"><a routerLink="/cart" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">السله (<span>{{quantityCounter}}</span>)</a></li>
                                    <!-- <li *ngIf="isLogged" class="nav-item"><a routerLink="/profile" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">الصفحة الشخصية</a></li> -->
                                    <li *ngIf="isLogged" class="nav-item"><a routerLink="/orders" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">طلباتي</a></li>
                                    <!-- <li *ngIf="isLogged" class="nav-item"><a routerLink="/favorites" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">المتاجر المفضلة</a></li> -->
                                    <!-- <li class="nav-item"><a routerLink="/favorite-products" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}">المنتجات المفضلة</a></li>  -->
                                    <li *ngIf="isLogged" class="nav-item"><a routerLink="/login-register" class="nav-link" routerLinkActive="active"[routerLinkActiveOptions]="{exact: true}" (click)="logOut()">تسجيل خروج</a></li>
                                    <a *ngIf="!isLogged" routerLink="/login-register" class="nav-link" routerLinkActive="active">تسجيل دخول</a>

                                    <!-- <li *ngIf="!isLogged" class="nav-item">
                                        <a href="javascript:void(0)" class="nav-link">
                                            <img *ngIf="isLogged" [src]="avatar" width="37" class="img-fluid">
                                            <a *ngIf="!isLogged" routerLink="/"><i class="flaticon-contact"></i></a>
                                        </a>
            
                                        <ul class="dropdown-menu">
                                            <li class="nav-item">
                                            </li>
                                        </ul>
                                    </li> -->
                                </ul>
                            </div>
                            <!-- <div class="user-btn">
                                <img *ngIf="isLogged" [src]="avatar" width="37" class="img-fluid">
                                <a *ngIf="!isLogged" routerLink="/"><i class="flaticon-contact"></i></a>
                            </div> -->
                        </div>

                        <!-- <div class="side-item">
                            <div class="nav-add-btn">
                                <a routerLink="/" class="default-btn border-radius">Add Listing <i class='bx bx-plus'></i></a>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="newNavBar" *ngIf="!showNavbar">
    <div class="goBackBtn text-end pe-4">
        <a (click)="goBack()"><i style="font-size: 25px;color: #fff !important;" class="fa fa-arrow-left"></i></a>
    </div>

     <!-- <a class="heart-btn" (click)="toggleFavourite(subCategoryID)" style="color: #000;position: absolute;top: 0;right: 20px;font-size: 28px;">
        <i *ngIf="isFav" class="fa fa-heart"></i>
        <i *ngIf="!isFav" class="fa-regular fa-heart"></i>
    </a> -->

    <a *ngIf="showCart && quantityCounter > 0" href="cart" class="cart_shopping" style="color: #000;position: absolute;top: 0;right: 20px;font-size: 28px;">
        <i class="fa fa-cart-shopping"></i>
        <span>{{quantityCounter}}</span>
    </a>
</div>

<div class="search-overlay">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="search-layer"></div>
            <div class="search-layer"></div>
            <div class="search-layer"></div>
            <div class="search-close">
                <span class="search-close-line"></span>
                <span class="search-close-line"></span>
            </div>

            <div class="search-form">
                <form>
                    <input type="text" class="input-search" placeholder="Search here...">
                    <button type="submit"><i class="flaticon-loupe"></i></button>
                </form>
            </div>
        </div>
    </div>
</div>